import {useEffect, useMemo, useState} from "react";
import { Card, Grid } from "@mui/material";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Vision UI Dashboard PRO React components
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";

// Vision UI Dashboard PRO React example components
import VehicleTypeTableCell from "layouts/homepage/components/VehicleTypeTable/VehicleTypeTableCell";
import {
  FreightIndexVehicleTypes,
  FreightIndexVehicleTypesLoggedIn
} from "../../data/freightIndexChart";
import VuiSelect from "../../../../components/VuiSelect";
import CircularProgress from "@mui/material/CircularProgress";

function VehicleTypeTable({ title, rows, onChange, loaderState, loggedIn, handleConfiguratorOpen }) {
  const [vehicleType, setVehicleType] = useState(FreightIndexVehicleTypes[0]);
  const [rowsData, setRowsData] = useState(rows);
  const [showloader, setShowloader] = useState(loaderState);

  const renderTableCells = rowsData.map((row, key) => {
    const tableRows = [];
    const rowKey = `row-${key}`;

    Object.entries(row).map(([cellTitle, cellContent]) =>
      Array.isArray(cellContent)
        ? tableRows.push(
            <VehicleTypeTableCell
              title={cellTitle}
              content={cellContent[1]}
              image={cellContent[0]}
              noBorder={key === rows.length - 1}
            />
          )
        : tableRows.push(
            <VehicleTypeTableCell
              title={cellTitle}
              content={!isNaN(cellContent) ? "₹" + cellContent : cellContent}
              noBorder={key === rows.length - 1}
            />
          )
    );

    return <TableRow key={rowKey}>{tableRows}</TableRow>;
  });

  const onVehicleTypeChange = (value) => {
    if(!value.isOpenMenu) {
      setVehicleType(value);
      onChange(value);
    } else {
      handleConfiguratorOpen();
    }
  };

  useEffect(() => {
    setRowsData(rows);
    setShowloader(loaderState);
  }, [rows, loaderState]);

  return (
    <>
      <Grid container mb={2}>
        <Grid item xs={12} lg={8}>
          <VuiBox mb={1}>
            <VuiTypography variant="h5" textTransform="capitalize"
              fontWeight="800"
              color="#3b3663">
              {title}
            </VuiTypography>
          </VuiBox>
        </Grid>
        <Grid item xs={6} lg={4}>
          <VuiSelect placeholder="Vehicle type" options={loggedIn ? FreightIndexVehicleTypesLoggedIn : FreightIndexVehicleTypes} name={"vehicle_type"} value={vehicleType} isClearable={false} onChange={onVehicleTypeChange} />
        </Grid>
      </Grid>
    <TableContainer sx={{ height: "100%", boxShadow: 'none', background: '#d4e3eb', overflow: 'inherit' }}>
      <Table sx={{overflowX: 'auto', display: { xs: 'block', md: 'table' }}}>
        {useMemo(() => renderTableCells, [rowsData])}
      </Table>
    </TableContainer>
      {showloader ?
        <Grid item xs={12} textAlign={"center"} top={"40%"}  position={"absolute"} width={"100%"}>
          <CircularProgress size={"4rem"} color={"white"}/>
        </Grid>
        :
        ""}
      </>
  );
}

// Setting default values for the props of VehicleTypeTable
VehicleTypeTable.defaultProps = {
  rows: [{}],
};

// Typechecking props for the VehicleTypeTable
VehicleTypeTable.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default VehicleTypeTable;
